import { lazyVue } from "@/utils";
export default [
  {
    path: '/pay',
    name: 'pay',
    title: '支付页',
    component: lazyVue('pay/index'),
    meta: {
      // showBar:1,
      isKeepAlive: true,
      title: '支付页',
      name: '支付页'
    }
  },
  {
    path: '/selectCard',
    name: 'selectCard',
    title: '选择会员卡',
    component: lazyVue('pay/selectCard/index'),
    meta: {
      // showBar:1,
      isKeepAlive: true,
      title: '选择会员卡',
      name: '选择会员卡'
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/pay/index.js